export default "__VITE_ASSET__8c00053b__"